import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const FAQs = () => {
  const { t } = useTranslation();

  const renderTextWithLinks = (text) => {
    if (!text) return null;
    const regex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})|(\+65\s?\d{4}\s?\d{4})|\[([^\]]+)\]|【([^】]+)】/g;
    const parts = text.split(regex);
    const elements = [];
    for (let i = 0; i < parts.length; i += 5) {
      if (parts[i]) {
        elements.push(parts[i]);
      }
      if (i + 1 < parts.length && parts[i + 1] !== undefined) {
        const email = parts[i + 1];
        elements.push(
          <a key={`email-${i}`} href={`mailto:${email}`}>
            {email}
          </a>
        );
      } else if (i + 2 < parts.length && parts[i + 2] !== undefined) {
        const wa = parts[i + 2];
        const cleanNum = wa.replace(/\s+/g, "");
        elements.push(
          <a key={`wa-${i}`} href={`https://wa.me/${cleanNum.replace("+", "")}`}>
            {wa}
          </a>
        );
      } else if (i + 3 < parts.length && parts[i + 3] !== undefined) {
        const linkText = parts[i + 3];
        elements.push(
          <Link key={`link-${i}`} to="/privacyinfo" style={{ color: "#38bdf8", textDecoration: "underline" }}>
            {linkText}
          </Link>
        );
      } else if (i + 4 < parts.length && parts[i + 4] !== undefined) {
        const linkText = parts[i + 4];
        elements.push(
          <Link key={`link-cn-${i}`} to="/privacyinfo" style={{ color: "#38bdf8", textDecoration: "underline" }}>
            {linkText}
          </Link>
        );
      }
    }
    return elements;
  };

  const FAQ_SECTIONS = [
    { key: "aboutApp", qCount: 3 },
    { key: "howItWorks", qCount: 4 },
    { key: "languages", qCount: 3 },
    { key: "accountFeatures", qCount: 13 },
    { key: "paymentsPurchases", qCount: 3 },
    { key: "consultations", qCount: 3 },
    { key: "support", qCount: 2 },
    { key: "privacyData", qCount: 2 },
    { key: "wisdomTraditions", qCount: 2 }
  ];

  const pageStyle = {
    maxWidth: "800px",
    margin: "20px auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
    color: "#dfbd69",
    borderRadius: "10px",
    backgroundColor: "transparent",
  };

  const headingStyle = {
    color: "#dfbd69",
    textAlign: "center",
    marginBottom: "20px",
  };

  const sectionHeadingStyle = {
    color: "#dfbd69",
    fontSize: "1.2rem",
    margin: "20px 0 10px 0",
  };

  const questionStyle = {
    fontWeight: "bold",
    marginTop: "15px",
    color: "#dfbd69",
  };

  const answerStyle = {
    color: "#dfbd69",
    whiteSpace: "pre-line",
    marginBottom: "15px",
    opacity: 0.95,
  };

  return (
    <div style={pageStyle}>
      <h1 style={headingStyle}>{t("faqPage.title")}</h1>
      <p style={{ textAlign: "center", marginBottom: "30px" }}>{t("faqPage.intro")}</p>

      {FAQ_SECTIONS.map((section) => (
        <div key={section.key}>
          <h2 style={sectionHeadingStyle}>{t(`faqPage.sections.${section.key}.title`)}</h2>
          <div>
            {Array.from({ length: section.qCount }).map((_, idx) => {
              const qNum = idx + 1;
              return (
                <div key={qNum}>
                  <p style={questionStyle}>Q: {t(`faqPage.sections.${section.key}.q${qNum}`)}</p>
                  <p style={answerStyle}>{renderTextWithLinks(t(`faqPage.sections.${section.key}.a${qNum}`))}</p>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQs;
